import React from 'react';
type CarouselDotsProps = {
  count: number;
  active: number;
  onSelect: (i: number) => void;
  tone?: 'light' | 'dark';
  className?: string;
};
export function CarouselDots({
  count,
  active,
  onSelect,
  tone = 'light',
  className = ''
}: CarouselDotsProps) {
  const on = tone === 'dark' ? 'bg-gold-400' : 'bg-terra-500';
  const off = tone === 'dark' ? 'bg-cream/25' : 'bg-beige-300';
  return <div className={`flex items-center justify-center gap-1.5 ${className}`} data-id="element-22" data-mp="2cqft8gvmajrj">
      {Array.from({
      length: count
    }).map((_, i) => <button key={i} type="button" onClick={() => onSelect(i)} aria-label={`Ir al elemento ${i + 1}`} className="flex h-6 items-center justify-center px-0.5" data-id="element-23" data-mp="27rla1dtqmt6w" data-mpi={i}>
          <span className={`block h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === active ? `w-5 ${on}` : `w-1.5 ${off}`}`} data-id="element-24" data-mp="2hho2ncwy654p" />
        </button>)}
    </div>;
}